import { BookingScheduleInterface } from "../../Booking-Form/typings/booking.types";
import { ResourceCalendarScheduleResponseDto } from "../typings/resource-calendar.types";

/**
 * Flattens resource-calendar response into a single list for the schedule UI.
 * Shapes align with existing place / noplacezone / vehicle schedule payloads.
 */
export function mergeResourceCalendarScheduleResponse(
  dto: ResourceCalendarScheduleResponseDto
): BookingScheduleInterface[] {
  const place = dto.placeSchedules ?? [];
  const placeZone = dto.placeZoneSchedules ?? [];
  const noPlace = dto.noPlaceZoneSchedules ?? [];
  const vehicle = dto.vehicleSchedules ?? [];

  return [...place, ...placeZone, ...noPlace, ...vehicle];
}
